import React from 'react';
import '../style/alert.css'

function Alert1(props) {
   
    return (
    <>
    <div className="alert1">
        <h2>{alert(props.alert)}</h2>   
    </div> 
    </>
    );
}

export default Alert1;